<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
    <md-card>
      <!-- <div class="md-layout-item md-size-33 md-medium-size-50 md-small-size-100">
                  <h5>Vehicle No</h5>
                  <md-radio v-model="radio" :value="1">Baik</md-radio>
                  <md-radio v-model="radio" :value="2">Tidak Baik/Rusak</md-radio><br/>
                  <md-radio v-model="radio" :value="3">Hilang</md-radio>
                  <md-radio v-model="radio" :value="4">N/A</md-radio>
                  <validation-error
                    :errors="apiValidationErrors.checker_vehicle_door_text"
                  />
              <validation-provider rules="vehicle" ref="checker_vehicle_door_text" v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Vehicle No</label>
                  <md-input />
                  <validation-error
                    :errors="apiValidationErrors.checker_vehicle_door_text"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
            </div> -->
      <md-card-content>
        <h5 style="font-weight:bold;">Perlengkapan Lain</h5>
        <div class="md-layout">
          <div class="md-layout-item md-medium-size-50 md-small-size-100">
            <h5>Mahkota</h5>
            <md-radio v-model="checker.checker_mahkota" :value="1">Baik</md-radio>
            <md-radio v-model="checker.checker_mahkota" :value="2">Tidak Baik/Rusak</md-radio>
            <md-radio v-model="checker.checker_mahkota" :value="3">Hilang</md-radio>
            <md-radio v-model="checker.checker_mahkota" :value="4">N/A</md-radio>
            <validation-error
                :errors="apiValidationErrors.checker_vehicle_door_text"
              />
          </div>
            
          <div class="md-layout-item md-medium-size-50 md-small-size-100" style="margin-top:40px;">

              <validation-provider v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Remark</label>
                  <md-input v-model="checker.checker_mahkota_remark"/>
                  <validation-error
                    :errors="apiValidationErrors.checker_mahkota_remark"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
          </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-medium-size-50 md-small-size-100">
            <h5>Argometer</h5>
            <md-radio v-model="checker.checker_argometer" :value="1">Baik</md-radio>
            <md-radio v-model="checker.checker_argometer" :value="2">Tidak Baik/Rusak</md-radio>
            <md-radio v-model="checker.checker_argometer" :value="3">Hilang</md-radio>
            <md-radio v-model="checker.checker_argometer" :value="4">N/A</md-radio>
            <validation-error
                :errors="apiValidationErrors.checker_vehicle_door_text"
              />
          </div>
            
          <div class="md-layout-item md-medium-size-50 md-small-size-100" style="margin-top:40px;">

              <validation-provider v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Remark</label>
                  <md-input v-model="checker.checker_argometer_remark"/>
                  <validation-error
                    :errors="apiValidationErrors.checker_argometer_remark"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
          </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-medium-size-50 md-small-size-100">
            <h5>Lampu Bahaya</h5>
            <md-radio v-model="checker.checker_lampu_bahaya" :value="1">Baik</md-radio>
            <md-radio v-model="checker.checker_lampu_bahaya" :value="2">Tidak Baik/Rusak</md-radio>
            <md-radio v-model="checker.checker_lampu_bahaya" :value="3">Hilang</md-radio>
            <md-radio v-model="checker.checker_lampu_bahaya" :value="4">N/A</md-radio>
            <validation-error
                :errors="apiValidationErrors.checker_vehicle_door_text"
              />
          </div>
            
          <div class="md-layout-item md-medium-size-50 md-small-size-100" style="margin-top:40px;">

              <validation-provider v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Remark</label>
                  <md-input v-model="checker.checker_lampu_bahaya_remark"/>
                  <validation-error
                    :errors="apiValidationErrors.checker_lampu_bahaya_remark"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
          </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-medium-size-50 md-small-size-100">
            <h5>Sticker Attribut Taksi</h5>
            <md-radio v-model="checker.checker_sticker_atribut_taksi" :value="1">Baik</md-radio>
            <md-radio v-model="checker.checker_sticker_atribut_taksi" :value="2">Tidak Baik/Rusak</md-radio>
            <md-radio v-model="checker.checker_sticker_atribut_taksi" :value="3">Hilang</md-radio>
            <md-radio v-model="checker.checker_sticker_atribut_taksi" :value="4">N/A</md-radio>
            <validation-error
                :errors="apiValidationErrors.checker_vehicle_door_text"
              />
          </div>
            
          <div class="md-layout-item md-medium-size-50 md-small-size-100" style="margin-top:40px;">

              <validation-provider v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Remark</label>
                  <md-input v-model="checker.checker_sticker_atribut_taksi_remark"/>
                  <validation-error
                    :errors="apiValidationErrors.checker_sticker_atribut_taksi_remark"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
          </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-medium-size-50 md-small-size-100">
            <h5>Lampu Vacant</h5>
            <md-radio v-model="checker.checker_lampu_vacant" :value="1">Baik</md-radio>
            <md-radio v-model="checker.checker_lampu_vacant" :value="2">Tidak Baik/Rusak</md-radio>
            <md-radio v-model="checker.checker_lampu_vacant" :value="3">Hilang</md-radio>
            <md-radio v-model="checker.checker_lampu_vacant" :value="4">N/A</md-radio>
            <validation-error
                :errors="apiValidationErrors.checker_vehicle_door_text"
              />
          </div>
            
          <div class="md-layout-item md-medium-size-50 md-small-size-100" style="margin-top:40px;">

              <validation-provider v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Remark</label>
                  <md-input v-model="checker.checker_lampu_vacant_remark"/>
                  <validation-error
                    :errors="apiValidationErrors.checker_lampu_vacant_remark"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
          </div>
        </div>

        

         <div class="md-layout-item">
          <autoextra :collection="photo" v-slot="{item,last,index}">
            <div  :class="{last: last}">
              <div v-if="item.photo_attach_view || item.url_photo_file || item.photo_remark || last" class="columns">
                <label :id="'labelAccesoriesFlag_'+index" style="font-weight:bold;" class="label">{{last ? 'New ' : ''}}Photo {{!last ? index + 1 : ''}}</label>
                <div class="md-layout md-gutter">

                  <div class="md-layout-item md-size-50 md-small-size-100" style="margin-bottom:10px;">
                  
                  <input v-model="item.id" :readonly="true" type="hidden"/>

                  

                  <div class="md-layout-item md-small-size-100">
                    <label class="md-layout-item md-size-15 md-form-label">Upload File/Photo</label>
                    <md-field class="md-invalid">
                      <md-file 
                      ref="stnk"
                        @change="on_change_attach_photo(item.photo_attach_view,index)"
                        v-model="item.photo_attach_view"
                        accept="image/jpeg,image/png"
                      />
                      <validation-error
                        :errors="apiValidationErrors.photo_attach"
                      />
                    </md-field>
                    <p v-if="item.photo_attach && item.photo_attach.type != 'image/jpeg' && item.photo_attach.type != 'image/png'" class="mb-0" style="text-align:center;">size: {{ (item.photo_attach.size / 1048576).toFixed(2) }}MB</p>
                  </div>
                  <div class="md-layout-item md-small-size-100" style="margin-bottom:10px;">
                    <md-field >
                      <label class="label" >Remark</label>
                      <md-textarea v-model="item.photo_remark" md-counter="150" maxlength="150" :disabled="!item.photo_attach_view && item.photo_attach_view != 0" md-autogrow></md-textarea>
                    </md-field>
                  </div>
                  </div>

                  <div class="md-layout-item md-size-50 md-small-size-100" style="margin-bottom:10px;">

                    <div class="border p-2 mt-3">
                      <template v-if="item.photo_attach">
                        <viewer class="pointer">
                        <img style="width: auto; max-height:400px; display: block; margin:auto;"
                          :src="item.photo_attach.base64"
                          class="img-fluid"
                        />
                        </viewer>
                        <!-- <p class="mb-0">file name: {{ file_attach_accesories.name }}</p> -->
                        <p class="mb-0">size: {{ (item.photo_attach.size / 1048576).toFixed(2) }}MB</p>
                      </template>
                      <template v-if="!item.photo_attach && item.url_photo_file">
                      <!-- <template v-if="!file_attach_accesories && item.url_photo_file"> -->
                        <template >
                          <span style="color:green"
                            >Current Photo:
                          </span>
                          <viewer class="pointer">
                          <img style="width: auto; max-height:400px; display: block; margin:auto;"
                              :src="item.url_photo_file"
                              
                              class="img-fluid"
                            />
                          </viewer>
                        </template>
                      </template>
                    </div>
                  </div>
                 
                  <md-card-actions style="border:none;">
                  <md-button class="md-danger md-dense"  @click="deleteColumn(index)" v-if="item.photo_attach_view || item.photo_attach_view==0 || item.photo_remark || item.url_photo_file">
                    delete
                  </md-button>
                  </md-card-actions>
                </div>            
              </div>
            </div>
            </autoextra>
          </div>
            
        
      </md-card-content>
    </md-card>
    </div>
  </div>
</template>

<script>
import { Modal } from "@/components";
import ListVehicle from "@/pages/Dashboard/Workshop/Checker/Modal/ListVehicle.vue";
import {ValidationError} from "@/components";
import formMixin from "@/mixins/form-mixin";
import { extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import Swal from 'sweetalert2';
import  Autoextra  from 'vue-autoextra';


  
  export default {
     name: "add-checker",

    props: ["checker"],

    components: {ValidationError,Autoextra },

    mixins: [formMixin],

    data: () => ({
      photo:[],
      // checker_dongkrak:null,
      // checker_dongkrak_remark:null,
      // checker_ban_serep_dan_kunci_roda:null,
      // checker_ban_serep_dan_kunci_roda_remark:null,
      // checker_segitiga_pengaman:null,
      // checker_segitiga_pengaman_remark:null,
      // checker_karpet_bagasi: null,
      // checker_karpet_bagasi_remark: null,
      // checker_p3k: null,
      // checker_p3k_remark: null,
      
      
    }),


  // created() {
  //         this.getListNota();
  //     },

  
    methods: {
       on_change_attach_photo(event,index) {
        console.log(index)
      var input = event.target;
      if(!input.files[0] || (input.files[0].size / 1048576).toFixed(2) > 3){
          if(input.files[0]){
          this.sizeTobig(input.files[0].size) 
          }
          // this.resetFile('photo_driver')
          // this.photo_attach = null
          // this.photo_attach = null
          console.log(input)
          this.$set(this.photo, index, {
                  id : this.photo[index].id,
                  photo_remark : this.photo[index].photo_remark,
                  photo_attach : null,
                  photo_attach_view : null,
                  url_photo_file : this.photo[index].url_photo_file,
                  photo_remark : this.photo[index].photo_remark
                  
                });

          
          //console.log(this.photo_attach)
          return
        }
      //check apakah data ada
      if (input.files) {
        var reader = new FileReader();
        //read file
        reader.onload = (e) => {
          //set array filedata
          const fileData = {
            name: input.files[0].name,
            size: input.files[0].size,
            lastModified: input.files[0].lastModified,
            lastModifiedDate: input.files[0].lastModifiedDate,
            type: input.files[0].type,
            base64: e.target.result,
          };
          //set var berdasarkan fildedata
          //this.photo_attach = fileData;
             console.log(this.photo[index]);
             if(this.photo[index]){
               this.$set(this.photo, index, {
                  id : this.photo[index].id,
                  photo_attach : fileData,
                   photo_attach_view : fileData.name,
                  url_photo_file : this.photo[index].url_photo_file,
                  photo_remark : this.photo[index].photo_remark
                  
                });
             }
             else{
               this.$set(this.photo, index, {
                  id : null,
                  photo_attach : fileData,
                   photo_attach_view : fileData.name,
                  url_photo_file : null,
                  photo_remark : null
                  
                });
             }
           

        };
        reader.readAsDataURL(input.files[0]);
      }
    },

    sizeTobig(size){
      Swal.fire({
          icon: 'error',
          title: 'File is to big ('+(size / 1048576).toFixed(2)+'MB)',
          text: 'Maximum attachment file size 3MB',
        })
    },


    deleteColumn(index){
        if (index > -1) {
           this.photo.splice(index, 1)
            var filtered = this.photo.filter(function (el) {
              return el != null;
            });
            this.photo = filtered;
        }
        
      },
    getData() {this.checker['images_bagian_taxi'] = this.photo
        this.$emit('data', this.checker)
       
    },

    async getDataParent() {
      this.photo = this.checker.checker_image_bagian_taxi
      this.checker.checker_image_bagian_taxi.forEach((value, index) => {

        //set data spare part dari data sparepart
        this.$set(this.photo, index, {
                  id : value.id,
                  photo_attach : null,
                   photo_attach_view : null,
                  url_photo_file : value.url_photo_file,
                  photo_remark : value.photo_remark
                  
                });
      });
    },
  }
};
</script>
